import { useParams } from 'react-router-dom';

import { decodeFlowCode } from '../flow/flowLink';
import { ChatWidget } from '../flow/ChatWidget';
import { FlowRunner } from '../flow/FlowRunner';
import { EmptySession } from '../ui/EmptySession';

/**
 * Mobile landing for a desktop→mobile handoff. The path carries the short-lived
 * `purpose='handoff'` runtime token minted by `collection/start`, as the 22-char
 * code of `flow/flowLink.ts` (it keeps the QR small). A bare uuid still opens —
 * a QR on screen while the release rolls out carries one. It is a valid applicant bearer (auth is purpose-agnostic;
 * the short TTL is its boundary), so it drives the flow exactly like the desktop
 * session — this device IS the phone, so no further handoff QR is shown.
 */
export function ResumeScreen() {
  const { token } = useParams<{ token: string }>();
  const raw = token?.trim() || null;
  const clean = raw && (decodeFlowCode(raw) ?? raw);

  if (!clean) {
    return <EmptySession kind="handoff" />;
  }

  return (
    <>
      <FlowRunner token={clean} />
      <ChatWidget token={clean} />
    </>
  );
}
